export const SvgShadowFilter = ({ id, uniqueId, x, y, width, height, radius, dy, blur, composite = false }) => (
  <filter
    id={id}
    x={x}
    y={y}
    width={width}
    height={height}
    filterUnits="userSpaceOnUse"
    colorInterpolationFilters="sRGB"
  >
    <feFlood floodOpacity={0} result="BackgroundImageFix" />
    <feColorMatrix
      in="SourceAlpha"
      type="matrix"
      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      result="hardAlpha"
    />
    <feMorphology
      radius={radius}
      operator="dilate"
      in="SourceAlpha"
      result={'effect1_dropShadow_' + uniqueId}
    />
    <feOffset dy={dy} />
    <feGaussianBlur stdDeviation={blur} />
    {composite && <feComposite in2="hardAlpha" operator="out" />}
    <feColorMatrix
      type="matrix"
      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
    />
    <feBlend
      mode="normal"
      in2="BackgroundImageFix"
      result={'effect1_dropShadow_' + uniqueId}
    />
    <feBlend
      mode="normal"
      in="SourceGraphic"
      in2={'effect1_dropShadow_' + uniqueId}
      result="shape"
    />
  </filter>
)

export const SvgImagePattern = ({ id, uniqueId, transform }) => (
  <pattern
    id={id}
    patternContentUnits="objectBoundingBox"
    width={1}
    height={1}
  >
    <use xlinkHref={'#image0_' + uniqueId} transform={transform} />
  </pattern>
)
